<div class="bg-modern-root" aria-hidden="true">
  <ng-container *ngFor="let it of items">
    <div
      class="bg-item"
      #bgItem
      *ngIf="activeTypes.includes(it.type) && isItemVisible(it)"
      [ngClass]="'is-' + it.type.toLowerCase()"
      [class.css-mode]="mode === 'css'"
      [style.width.px]="it.size"
      [style.height.px]="it.size"
      [style.opacity]="it.opacity"
      [style.filter]="'blur(' + it.blur + 'px)'"
      [style.transform]="
        'translate3d(var(--tx), var(--ty), 0) rotate(' + it.angle + 'deg)'
      "
      [style.--sx]="mode === 'css' ? it.sx + 'px' : null"
      [style.--sy]="mode === 'css' ? it.sy + 'px' : null"
      [style.--ex]="mode === 'css' ? it.ex + 'px' : null"
      [style.--ey]="mode === 'css' ? it.ey + 'px' : null"
      [style.--dur]="mode === 'css' ? it.durS + 's' : null"
      [style.--delay]="mode === 'css' ? it.delayS + 's' : null"
      [style.--tx]="mode === 'css' ? it.sx + 'px' : null"
      [style.--ty]="mode === 'css' ? it.sy + 'px' : null"
      [attr.data-id]="it.id"
    >
      <img
        [src]="'assets/design-modern/background/' + iconMap[it.type]"
        [style.width.px]="it.size"
        [style.height.px]="it.size"
      />
    </div>
  </ng-container>
</div>
